import { render, staticRenderFns } from "./ReferralMappingCard.vue?vue&type=template&id=edabe87e&"
import script from "./ReferralMappingCard.vue?vue&type=script&lang=js&"
export * from "./ReferralMappingCard.vue?vue&type=script&lang=js&"
import style0 from "./ReferralMappingCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports